import router from './router'
import { useToastStore } from './store'

export default {
  router,
  useToastStore,
}
